import { PagingFilterType } from "@nms-angular-toolkit/nms-table";
import { FilterTypeMapping, PageFilterFunction } from "@nms-ng2/app/modules/device/gpon-onus/gpon-onus.models";

export const startOrEndsWithFunction : PageFilterFunction = function(value) : PagingFilterType { // nosonar
    if (value.startsWith("%")) {
        return PagingFilterType.ENDS_WITH;
    }

    if (value.endsWith("%")) {
        return PagingFilterType.STARTS_WITH;
    }
}

/**
 * Mapa entre as strings usadas para comparação e as funções respectivas.
 */
export const FILTER_TYPE_BY_SYMBOL: FilterTypeMapping = {
    "||" : (value) => PagingFilterType.BETWEEN,
    "="  : (value) => PagingFilterType.EQUALS,
    "!"  : (value) => PagingFilterType.NOT_EQUALS,
    ">"  : (value) => PagingFilterType.GREATER_THAN,
    "<"  : (value) => PagingFilterType.LESS_THAN,
    ">=" : (value) => PagingFilterType.GREATER_OR_EQUALS,
    "<=" : (value) => PagingFilterType.LESS_OR_EQUALS,
    "!!" : (value) => PagingFilterType.NOT_CONTAINS,
    "%"  : startOrEndsWithFunction,
    "''" : (value) => PagingFilterType.CONTAINS,
    "*"  : (value) => PagingFilterType.INCLUDES
}
